import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";
import {isVendorExcludedFromHidePrices} from "./is_vendor_excluded_from_hide_prices";

export interface IGetShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
}

export const getShowPrice = ({offerPriceVisibility, vendorPriceVisibility, vendorId}: IGetShowPriceParams) => {
    if (!offerPriceVisibility || !vendorPriceVisibility) {
        return false;
    }

    const offerPriceVisibilityNever = offerPriceVisibility === PriceVisibilityType.NEVER;
    const offerPriceVisibilityAuto = offerPriceVisibility === PriceVisibilityType.AUTO;
    const vendorPriceVisibilityNever = vendorPriceVisibility === PriceVisibilityType.NEVER;
    // INFO: For now remove price visibility based on property.show_price - because with this logic we are not able to hide price in base AB test variant.

    // If vendor is excluded from hiding prices, always show prices according to original logic
    if (vendorId && isVendorExcludedFromHidePrices(vendorId)) {
        return true;
    }

    // Hide price if offer explicitly says NEVER
    if (offerPriceVisibilityNever) {
        return false;
    }

    // Hide price if offer is AUTO and vendor says NEVER
    if (offerPriceVisibilityAuto && vendorPriceVisibilityNever) {
        return false;
    }

    return true;
};
import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";
import {isVendorExcludedFromHidePrices} from "./is_vendor_excluded_from_hide_prices";

export interface IGetShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
}

export const getShowPrice = ({offerPriceVisibility, vendorPriceVisibility, vendorId}: IGetShowPriceParams) => {
    if (!offerPriceVisibility || !vendorPriceVisibility) {
        return false;
    }

    const offerPriceVisibilityNever = offerPriceVisibility === PriceVisibilityType.NEVER;
    const offerPriceVisibilityAuto = offerPriceVisibility === PriceVisibilityType.AUTO;
    const vendorPriceVisibilityNever = vendorPriceVisibility === PriceVisibilityType.NEVER;
    // INFO: For now remove price visibility based on property.show_price - because with this logic we are not able to hide price in base AB test variant.

    // If vendor is excluded from hiding prices, always show prices according to original logic
    if (vendorId && isVendorExcludedFromHidePrices(vendorId)) {
        return true;
    }

    // Hide price if offer explicitly says NEVER
    if (offerPriceVisibilityNever) {
        return false;
    }

    // Hide price if offer is AUTO and vendor says NEVER
    if (offerPriceVisibilityAuto && vendorPriceVisibilityNever) {
        return false;
    }

    return true;
};
